import awardConstants, { awardStatuses } from '../../../utils/awardConstants';
import awardSelectors from '../awards/selectors';

// Get Distinct Award Categories
const getAwardCategories = ({ data: awards }) =>
    Object.keys(awards)
        .filter((award) => award !== awardConstants.OTHER)
        .map((award) => ({
            label: award,
            value: award.toLowerCase(),
            ...awards[award][0].trophyCategory,
        }));

const groupDataByKey = (data, accessor, expander) => {
    const reducedData = data.reduce((acc, item) => {
        const itemKey = typeof accessor === 'string' ? item[accessor] : accessor(item);
        if (!acc[itemKey]) {
            const values = expander ? expander(item) || {} : {};
            acc[itemKey] = {
                ...values,
                data: [],
            };
        }
        acc[itemKey].data.push(item);
        return acc;
    }, {});
    return Object.keys(reducedData).map((key) => reducedData[key]);
};

const groupFranchiseTrophies = (data) => {
    const allTrophies = data.map((award) => {
        if (award[awardStatuses.WINNER]) {
            award.trophy = award[awardStatuses.WINNER][0].trophy;
        } else if (award[awardStatuses.RUNNER_UP]) {
            award.trophy = award[awardStatuses.RUNNER_UP][0].trophy;
        } else if (award[awardStatuses.FINALIST]) {
            award.trophy = award[awardStatuses.FINALIST][0].trophy;
        }
        return award;
    });

    const groupedTrophies = groupDataByKey(
        allTrophies,
        (item) => item.trophy.id,
        (i) => ({ trophy: awardSelectors.addAwardSlug(i.trophy) })
    );
    groupedTrophies.sort((a, b) => {
        if (a.trophy.name.toLowerCase() === 'stanley cup') {
            return -1;
        }
        if (b.trophy.name.toLowerCase() === 'stanley cup') {
            return 1;
        }
        return a.trophy.name.localeCompare(b.trophy.name);
    });

    return groupedTrophies.map((groupedTrophy) => {
        const seasonAwardMap = awardSelectors.groupRecordsBySeasonStatus(groupedTrophy.data);
        const data = awardSelectors.getAwardsBySeason(seasonAwardMap);
        return {
            data,
            trophy: groupedTrophy.trophy,
        };
    });
};

export default {
    getAwardCategories,
    groupFranchiseTrophies,
};
